import React                        from 'react';
import { qfnPlacements as tooltip } from 'pu-data/Tooltips';
import TextComponent                from './base/TextComponent';

const QfnPlacements = (props) => {
  const name = 'qfn';
  const onChange = (e) => props.onChangeParameter(name, e.target.value, props.itemId);

  return (
    <TextComponent
      label="QFN"
      name={name}
      type={props.type}
      inputId={props.inputId}
      value={props.parameters[name]}
      required={props.required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      error={props.error} />
  );
};

QfnPlacements.defaultProps = {
  inputId: 'qfn-placement',
  itemId: '',
};

export default QfnPlacements;
